<div class="w-full h-full bg-white p-2 search-widget-v3-desktop-expanded flex flex-col gap-1">
  <div class="search-widget-v3-desktop-expanded__heading">
    <!--    <app-ui-icon name="close" size="md" (onClick)="toggleSearchWidget()"></app-ui-icon>-->
    <app-ui-icon-button
      (onClick)="toggleSearchWidget()"
      class="absolute right-0 top-0 inline-block"
      icon="close"
      iconColor="--grey-3"
    ></app-ui-icon-button>

    <div>Vad letar du efter?</div>
  </div>

  <div class="flex flex-row gap-4 justify-between items-center w-[1208px] max-w-[1208px] mx-auto">
    <div class="basis-48 w-48">
      @if (whichIsFocused() === SearchWidgetFreeSearchFieldsEnum.FREESEARCH) {
        <app-ui-button
          (onClick)="onCategoriesClick()"
          [color]="'tertiary'"
          [disabled]="false"
          [expanded]="'block'"
          [size]="'lg'"
          class="test-mega-menu-button w-full"
        >
          <app-ui-icon name="list"></app-ui-icon>
          Alla kategorier
        </app-ui-button>
      }
      @if (whichIsFocused() === SearchWidgetFreeSearchFieldsEnum.PLACE) {
        <app-ui-button
          (onClick)="onPlacesClick()"
          [color]="'tertiary'"
          [disabled]="false"
          [expanded]="'block'"
          [size]="'lg'"
          class="test-mega-menu-button w-full"
        >
          <app-ui-icon name="place_marker"></app-ui-icon>
          Se alla platser
        </app-ui-button>
      }
    </div>


    <app-search-widget-v3-free-search-form
      (fieldFocused)="onFreeSearchFieldFocused($event)"
      [shouldGetFocus]="!shouldFocusPlacesField()"
      class="basis-2/5"></app-search-widget-v3-free-search-form>

    <app-search-widget-v3-places-form
      (fieldFocused)="onPlacesFieldFocused($event)"
      [shouldGetFocus]="shouldFocusPlacesField()"
      class="basis-2/5">
    </app-search-widget-v3-places-form>

    <div class="basis-40 w-40">
      <app-ui-button
        (onClick)="onSubmitClick()"
        [color]="'green'"
        [disabled]="!isSubmitButtonActive()"
        [expanded]="'block'"
        [size]="'lg'"
        class="test-search-btn w-full"
      >
        Sök
      </app-ui-button>
    </div>

  </div>


  @if (isDesktopSuggestionsPanelOpen()) {
    <div class="search-widget-v3-desktop-expanded__suggestions pl-52 pt-4 pr-44 w-[1208px]  max-w-[1208px] mx-auto">
      <app-search-widget-v3-suggestions
        [whichIsFocused]="whichIsFocused()"
      ></app-search-widget-v3-suggestions>
    </div>
  } @else {
    <div class=" pl-52 pt-4 pr-44 w-[1208px] max-w-[1208px] mx-auto">
      @if (desktopCategoriesPanelOpen()) {
        <app-search-categories-v3 [showBackButtonInline]="true"></app-search-categories-v3>
      }

      @if (desktopPlacesPanelOpen()) {
        <app-search-places-v3 [showCloseButton]="false"></app-search-places-v3>
      }
    </div>
  }
</div>
